// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "membership.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "membership.proto" (syntax proto3)
// tslint:disable
import { Bool } from "./common";
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Property } from "./property";
import { User } from "./user";
import { Contract } from "./event";
// @generated message type with reflection information, may provide speed optimized methods
class Membership$Type extends MessageType {
    constructor() {
        super("Membership", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "membership_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "date_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "date_ended", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 36, name: "contract_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "cancel_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "cancel_timing", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "cancel_effective_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "created_by_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "channel_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "pm_visits", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "status_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 35, name: "sold_on_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "membership_type", kind: "message", T: () => MembershipType },
            { no: 22, name: "contract", kind: "message", T: () => Contract },
            { no: 23, name: "customer", kind: "message", T: () => User },
            { no: 24, name: "property", kind: "message", T: () => Property },
            { no: 25, name: "is_commercial", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 26, name: "maintenance_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 27, name: "lines_total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 28, name: "base_line_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "with_type", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 30, name: "with_contract", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 31, name: "with_customer", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 32, name: "with_property", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 33, name: "with_lines", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.contractId = 0;
        message.membershipTypeId = 0;
        message.propertyId = 0;
        message.dateCreated = "";
        message.dateStarted = "";
        message.dateEnded = "";
        message.isActive = false;
        message.notes = "";
        message.fieldMask = [];
        message.orderBy = "";
        message.orderDir = "";
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.contractIdList = "";
        message.cancelReason = "";
        message.cancelTiming = "";
        message.cancelEffectiveDate = "";
        message.createdByUserId = 0;
        message.channelId = 0;
        message.pmVisits = "";
        message.statusId = 0;
        message.soldOnEventId = 0;
        message.isCommercial = false;
        message.maintenanceCount = 0;
        message.linesTotal = 0;
        message.baseLineName = "";
        message.withType = false;
        message.withContract = false;
        message.withCustomer = false;
        message.withProperty = false;
        message.withLines = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 contract_id */ 2:
                    message.contractId = reader.int32();
                    break;
                case /* int32 membership_type_id */ 3:
                    message.membershipTypeId = reader.int32();
                    break;
                case /* int32 property_id */ 4:
                    message.propertyId = reader.int32();
                    break;
                case /* string date_created */ 5:
                    message.dateCreated = reader.string();
                    break;
                case /* string date_started */ 6:
                    message.dateStarted = reader.string();
                    break;
                case /* string date_ended */ 7:
                    message.dateEnded = reader.string();
                    break;
                case /* bool is_active */ 8:
                    message.isActive = reader.bool();
                    break;
                case /* string notes */ 9:
                    message.notes = reader.string();
                    break;
                case /* repeated string field_mask */ 10:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string order_by */ 11:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 12:
                    message.orderDir = reader.string();
                    break;
                case /* int32 page_number */ 13:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 14:
                    message.withoutLimit = reader.bool();
                    break;
                case /* string contract_id_list */ 36:
                    message.contractIdList = reader.string();
                    break;
                case /* string cancel_reason */ 15:
                    message.cancelReason = reader.string();
                    break;
                case /* string cancel_timing */ 16:
                    message.cancelTiming = reader.string();
                    break;
                case /* string cancel_effective_date */ 17:
                    message.cancelEffectiveDate = reader.string();
                    break;
                case /* int32 created_by_user_id */ 18:
                    message.createdByUserId = reader.int32();
                    break;
                case /* int32 channel_id */ 19:
                    message.channelId = reader.int32();
                    break;
                case /* string pm_visits */ 20:
                    message.pmVisits = reader.string();
                    break;
                case /* int32 status_id */ 34:
                    message.statusId = reader.int32();
                    break;
                case /* int32 sold_on_event_id */ 35:
                    message.soldOnEventId = reader.int32();
                    break;
                case /* MembershipType membership_type */ 21:
                    message.membershipType = MembershipType.internalBinaryRead(reader, reader.uint32(), options, message.membershipType);
                    break;
                case /* Contract contract */ 22:
                    message.contract = Contract.internalBinaryRead(reader, reader.uint32(), options, message.contract);
                    break;
                case /* User customer */ 23:
                    message.customer = User.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* Property property */ 24:
                    message.property = Property.internalBinaryRead(reader, reader.uint32(), options, message.property);
                    break;
                case /* bool is_commercial */ 25:
                    message.isCommercial = reader.bool();
                    break;
                case /* int32 maintenance_count */ 26:
                    message.maintenanceCount = reader.int32();
                    break;
                case /* double lines_total */ 27:
                    message.linesTotal = reader.double();
                    break;
                case /* string base_line_name */ 28:
                    message.baseLineName = reader.string();
                    break;
                case /* bool with_type */ 29:
                    message.withType = reader.bool();
                    break;
                case /* bool with_contract */ 30:
                    message.withContract = reader.bool();
                    break;
                case /* bool with_customer */ 31:
                    message.withCustomer = reader.bool();
                    break;
                case /* bool with_property */ 32:
                    message.withProperty = reader.bool();
                    break;
                case /* bool with_lines */ 33:
                    message.withLines = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 contract_id = 2; */
        if (message.contractId !== 0)
            writer.tag(2, WireType.Varint).int32(message.contractId);
        /* int32 membership_type_id = 3; */
        if (message.membershipTypeId !== 0)
            writer.tag(3, WireType.Varint).int32(message.membershipTypeId);
        /* int32 property_id = 4; */
        if (message.propertyId !== 0)
            writer.tag(4, WireType.Varint).int32(message.propertyId);
        /* string date_created = 5; */
        if (message.dateCreated !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.dateCreated);
        /* string date_started = 6; */
        if (message.dateStarted !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.dateStarted);
        /* string date_ended = 7; */
        if (message.dateEnded !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.dateEnded);
        /* bool is_active = 8; */
        if (message.isActive !== false)
            writer.tag(8, WireType.Varint).bool(message.isActive);
        /* string notes = 9; */
        if (message.notes !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.notes);
        /* repeated string field_mask = 10; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string order_by = 11; */
        if (message.orderBy !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 12; */
        if (message.orderDir !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderDir);
        /* int32 page_number = 13; */
        if (message.pageNumber !== 0)
            writer.tag(13, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 14; */
        if (message.withoutLimit !== false)
            writer.tag(14, WireType.Varint).bool(message.withoutLimit);
        /* string cancel_reason = 15; */
        if (message.cancelReason !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.cancelReason);
        /* string cancel_timing = 16; */
        if (message.cancelTiming !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.cancelTiming);
        /* string cancel_effective_date = 17; */
        if (message.cancelEffectiveDate !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.cancelEffectiveDate);
        /* int32 created_by_user_id = 18; */
        if (message.createdByUserId !== 0)
            writer.tag(18, WireType.Varint).int32(message.createdByUserId);
        /* int32 channel_id = 19; */
        if (message.channelId !== 0)
            writer.tag(19, WireType.Varint).int32(message.channelId);
        /* string pm_visits = 20; */
        if (message.pmVisits !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.pmVisits);
        /* MembershipType membership_type = 21; */
        if (message.membershipType)
            MembershipType.internalBinaryWrite(message.membershipType, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* Contract contract = 22; */
        if (message.contract)
            Contract.internalBinaryWrite(message.contract, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* User customer = 23; */
        if (message.customer)
            User.internalBinaryWrite(message.customer, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* Property property = 24; */
        if (message.property)
            Property.internalBinaryWrite(message.property, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        /* bool is_commercial = 25; */
        if (message.isCommercial !== false)
            writer.tag(25, WireType.Varint).bool(message.isCommercial);
        /* int32 maintenance_count = 26; */
        if (message.maintenanceCount !== 0)
            writer.tag(26, WireType.Varint).int32(message.maintenanceCount);
        /* double lines_total = 27; */
        if (message.linesTotal !== 0)
            writer.tag(27, WireType.Bit64).double(message.linesTotal);
        /* string base_line_name = 28; */
        if (message.baseLineName !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.baseLineName);
        /* bool with_type = 29; */
        if (message.withType !== false)
            writer.tag(29, WireType.Varint).bool(message.withType);
        /* bool with_contract = 30; */
        if (message.withContract !== false)
            writer.tag(30, WireType.Varint).bool(message.withContract);
        /* bool with_customer = 31; */
        if (message.withCustomer !== false)
            writer.tag(31, WireType.Varint).bool(message.withCustomer);
        /* bool with_property = 32; */
        if (message.withProperty !== false)
            writer.tag(32, WireType.Varint).bool(message.withProperty);
        /* bool with_lines = 33; */
        if (message.withLines !== false)
            writer.tag(33, WireType.Varint).bool(message.withLines);
        /* int32 status_id = 34; */
        if (message.statusId !== 0)
            writer.tag(34, WireType.Varint).int32(message.statusId);
        /* int32 sold_on_event_id = 35; */
        if (message.soldOnEventId !== 0)
            writer.tag(35, WireType.Varint).int32(message.soldOnEventId);
        /* string contract_id_list = 36; */
        if (message.contractIdList !== "")
            writer.tag(36, WireType.LengthDelimited).string(message.contractIdList);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Membership
 */
export const Membership = new Membership$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PmVisit$Type extends MessageType {
    constructor() {
        super("PmVisit", [
            { no: 1, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "job_subtype_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "services_needed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "planned_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "amount_quoted", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "payment_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.departmentId = 0;
        message.jobTypeId = 0;
        message.jobSubtypeId = 0;
        message.servicesNeeded = "";
        message.notes = "";
        message.plannedDate = "";
        message.amountQuoted = "";
        message.paymentStatus = "";
        message.status = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 department_id */ 1:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 job_type_id */ 2:
                    message.jobTypeId = reader.int32();
                    break;
                case /* int32 job_subtype_id */ 3:
                    message.jobSubtypeId = reader.int32();
                    break;
                case /* string services_needed */ 4:
                    message.servicesNeeded = reader.string();
                    break;
                case /* string notes */ 5:
                    message.notes = reader.string();
                    break;
                case /* string planned_date */ 6:
                    message.plannedDate = reader.string();
                    break;
                case /* string amount_quoted */ 7:
                    message.amountQuoted = reader.string();
                    break;
                case /* string payment_status */ 8:
                    message.paymentStatus = reader.string();
                    break;
                case /* string status */ 9:
                    message.status = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 department_id = 1; */
        if (message.departmentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.departmentId);
        /* int32 job_type_id = 2; */
        if (message.jobTypeId !== 0)
            writer.tag(2, WireType.Varint).int32(message.jobTypeId);
        /* int32 job_subtype_id = 3; */
        if (message.jobSubtypeId !== 0)
            writer.tag(3, WireType.Varint).int32(message.jobSubtypeId);
        /* string services_needed = 4; */
        if (message.servicesNeeded !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.servicesNeeded);
        /* string notes = 5; */
        if (message.notes !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.notes);
        /* string planned_date = 6; */
        if (message.plannedDate !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.plannedDate);
        /* string amount_quoted = 7; */
        if (message.amountQuoted !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.amountQuoted);
        /* string payment_status = 8; */
        if (message.paymentStatus !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.paymentStatus);
        /* string status = 9; */
        if (message.status !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PmVisit
 */
export const PmVisit = new PmVisit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipList$Type extends MessageType {
    constructor() {
        super("MembershipList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Membership },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Membership results */ 1:
                    message.results.push(Membership.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Membership results = 1; */
        for (let i = 0; i < message.results.length; i++)
            Membership.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipList
 */
export const MembershipList = new MembershipList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipWithLines$Type extends MessageType {
    constructor() {
        super("MembershipWithLines", [
            { no: 1, name: "membership", kind: "message", T: () => Membership },
            { no: 2, name: "lines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MembershipInstanceLine }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.lines = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* Membership membership */ 1:
                    message.membership = Membership.internalBinaryRead(reader, reader.uint32(), options, message.membership);
                    break;
                case /* repeated MembershipInstanceLine lines */ 2:
                    message.lines.push(MembershipInstanceLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* Membership membership = 1; */
        if (message.membership)
            Membership.internalBinaryWrite(message.membership, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated MembershipInstanceLine lines = 2; */
        for (let i = 0; i < message.lines.length; i++)
            MembershipInstanceLine.internalBinaryWrite(message.lines[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipWithLines
 */
export const MembershipWithLines = new MembershipWithLines$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchCreateMembershipRequest$Type extends MessageType {
    constructor() {
        super("BatchCreateMembershipRequest", [
            { no: 1, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MembershipWithLines }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MembershipWithLines items */ 1:
                    message.items.push(MembershipWithLines.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MembershipWithLines items = 1; */
        for (let i = 0; i < message.items.length; i++)
            MembershipWithLines.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BatchCreateMembershipRequest
 */
export const BatchCreateMembershipRequest = new BatchCreateMembershipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipType$Type extends MessageType {
    constructor() {
        super("MembershipType", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "helcim_plan_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "program", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "tier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "pre_drafted_pm_jobs", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "terms_copy", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "last_verified_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "pm_visit_templates", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "included_filters_with_pm", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.description = "";
        message.cost = 0;
        message.isActive = false;
        message.dateCreated = "";
        message.helcimPlanId = 0;
        message.program = "";
        message.tier = "";
        message.preDraftedPmJobs = 0;
        message.termsCopy = "";
        message.lastVerifiedDate = "";
        message.pmVisitTemplates = "";
        message.includedFiltersWithPm = false;
        message.orderBy = "";
        message.orderDir = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* double cost */ 4:
                    message.cost = reader.double();
                    break;
                case /* bool is_active */ 5:
                    message.isActive = reader.bool();
                    break;
                case /* string date_created */ 6:
                    message.dateCreated = reader.string();
                    break;
                case /* int32 helcim_plan_id */ 12:
                    message.helcimPlanId = reader.int32();
                    break;
                case /* string program */ 13:
                    message.program = reader.string();
                    break;
                case /* string tier */ 14:
                    message.tier = reader.string();
                    break;
                case /* int32 pre_drafted_pm_jobs */ 15:
                    message.preDraftedPmJobs = reader.int32();
                    break;
                case /* string terms_copy */ 16:
                    message.termsCopy = reader.string();
                    break;
                case /* string last_verified_date */ 17:
                    message.lastVerifiedDate = reader.string();
                    break;
                case /* string pm_visit_templates */ 18:
                    message.pmVisitTemplates = reader.string();
                    break;
                case /* bool included_filters_with_pm */ 19:
                    message.includedFiltersWithPm = reader.bool();
                    break;
                case /* string order_by */ 7:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 8:
                    message.orderDir = reader.string();
                    break;
                case /* repeated string field_mask */ 9:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 10:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 11:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* double cost = 4; */
        if (message.cost !== 0)
            writer.tag(4, WireType.Bit64).double(message.cost);
        /* bool is_active = 5; */
        if (message.isActive !== false)
            writer.tag(5, WireType.Varint).bool(message.isActive);
        /* string date_created = 6; */
        if (message.dateCreated !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.dateCreated);
        /* string order_by = 7; */
        if (message.orderBy !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 8; */
        if (message.orderDir !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.orderDir);
        /* repeated string field_mask = 9; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 10; */
        if (message.pageNumber !== 0)
            writer.tag(10, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 11; */
        if (message.withoutLimit !== false)
            writer.tag(11, WireType.Varint).bool(message.withoutLimit);
        /* int32 helcim_plan_id = 12; */
        if (message.helcimPlanId !== 0)
            writer.tag(12, WireType.Varint).int32(message.helcimPlanId);
        /* string program = 13; */
        if (message.program !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.program);
        /* string tier = 14; */
        if (message.tier !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.tier);
        /* int32 pre_drafted_pm_jobs = 15; */
        if (message.preDraftedPmJobs !== 0)
            writer.tag(15, WireType.Varint).int32(message.preDraftedPmJobs);
        /* string terms_copy = 16; */
        if (message.termsCopy !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.termsCopy);
        /* string last_verified_date = 17; */
        if (message.lastVerifiedDate !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.lastVerifiedDate);
        /* string pm_visit_templates = 18; */
        if (message.pmVisitTemplates !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.pmVisitTemplates);
        /* bool included_filters_with_pm = 19; */
        if (message.includedFiltersWithPm !== false)
            writer.tag(19, WireType.Varint).bool(message.includedFiltersWithPm);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipType
 */
export const MembershipType = new MembershipType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipTypeList$Type extends MessageType {
    constructor() {
        super("MembershipTypeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MembershipType },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MembershipType results */ 1:
                    message.results.push(MembershipType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MembershipType results = 1; */
        for (let i = 0; i < message.results.length; i++)
            MembershipType.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipTypeList
 */
export const MembershipTypeList = new MembershipTypeList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipLine$Type extends MessageType {
    constructor() {
        super("MembershipLine", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "helcim_addon_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "last_verified_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.description = "";
        message.isActive = false;
        message.sortOrder = 0;
        message.helcimAddonId = 0;
        message.lastVerifiedDate = "";
        message.orderBy = "";
        message.orderDir = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* bool is_active */ 4:
                    message.isActive = reader.bool();
                    break;
                case /* int32 sort_order */ 5:
                    message.sortOrder = reader.int32();
                    break;
                case /* int32 helcim_addon_id */ 11:
                    message.helcimAddonId = reader.int32();
                    break;
                case /* string last_verified_date */ 12:
                    message.lastVerifiedDate = reader.string();
                    break;
                case /* string order_by */ 6:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 7:
                    message.orderDir = reader.string();
                    break;
                case /* repeated string field_mask */ 8:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 9:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 10:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* bool is_active = 4; */
        if (message.isActive !== false)
            writer.tag(4, WireType.Varint).bool(message.isActive);
        /* int32 sort_order = 5; */
        if (message.sortOrder !== 0)
            writer.tag(5, WireType.Varint).int32(message.sortOrder);
        /* string order_by = 6; */
        if (message.orderBy !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 7; */
        if (message.orderDir !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.orderDir);
        /* repeated string field_mask = 8; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 9; */
        if (message.pageNumber !== 0)
            writer.tag(9, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 10; */
        if (message.withoutLimit !== false)
            writer.tag(10, WireType.Varint).bool(message.withoutLimit);
        /* int32 helcim_addon_id = 11; */
        if (message.helcimAddonId !== 0)
            writer.tag(11, WireType.Varint).int32(message.helcimAddonId);
        /* string last_verified_date = 12; */
        if (message.lastVerifiedDate !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.lastVerifiedDate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipLine
 */
export const MembershipLine = new MembershipLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipLineList$Type extends MessageType {
    constructor() {
        super("MembershipLineList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MembershipLine },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MembershipLine results */ 1:
                    message.results.push(MembershipLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MembershipLine results = 1; */
        for (let i = 0; i < message.results.length; i++)
            MembershipLine.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipLineList
 */
export const MembershipLineList = new MembershipLineList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipTypeLine$Type extends MessageType {
    constructor() {
        super("MembershipTypeLine", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "membership_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "membership_line_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "is_included", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.membershipTypeId = 0;
        message.membershipLineId = 0;
        message.isIncluded = false;
        message.cost = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 membership_type_id */ 2:
                    message.membershipTypeId = reader.int32();
                    break;
                case /* int32 membership_line_id */ 3:
                    message.membershipLineId = reader.int32();
                    break;
                case /* bool is_included */ 4:
                    message.isIncluded = reader.bool();
                    break;
                case /* double cost */ 5:
                    message.cost = reader.double();
                    break;
                case /* string order_by */ 6:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 7:
                    message.orderDir = reader.string();
                    break;
                case /* repeated string field_mask */ 8:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 9:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 10:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 membership_type_id = 2; */
        if (message.membershipTypeId !== 0)
            writer.tag(2, WireType.Varint).int32(message.membershipTypeId);
        /* int32 membership_line_id = 3; */
        if (message.membershipLineId !== 0)
            writer.tag(3, WireType.Varint).int32(message.membershipLineId);
        /* bool is_included = 4; */
        if (message.isIncluded !== false)
            writer.tag(4, WireType.Varint).bool(message.isIncluded);
        /* double cost = 5; */
        if (message.cost !== 0)
            writer.tag(5, WireType.Bit64).double(message.cost);
        /* string order_by = 6; */
        if (message.orderBy !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 7; */
        if (message.orderDir !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.orderDir);
        /* repeated string field_mask = 8; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 9; */
        if (message.pageNumber !== 0)
            writer.tag(9, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 10; */
        if (message.withoutLimit !== false)
            writer.tag(10, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipTypeLine
 */
export const MembershipTypeLine = new MembershipTypeLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipTypeLineList$Type extends MessageType {
    constructor() {
        super("MembershipTypeLineList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MembershipTypeLine },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MembershipTypeLine results */ 1:
                    message.results.push(MembershipTypeLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MembershipTypeLine results = 1; */
        for (let i = 0; i < message.results.length; i++)
            MembershipTypeLine.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipTypeLineList
 */
export const MembershipTypeLineList = new MembershipTypeLineList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipInstanceLine$Type extends MessageType {
    constructor() {
        super("MembershipInstanceLine", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "membership_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "membership_line_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "is_included", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.membershipId = 0;
        message.membershipLineId = 0;
        message.name = "";
        message.description = "";
        message.isIncluded = false;
        message.cost = 0;
        message.sortOrder = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 membership_id */ 2:
                    message.membershipId = reader.int32();
                    break;
                case /* int32 membership_line_id */ 3:
                    message.membershipLineId = reader.int32();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* bool is_included */ 6:
                    message.isIncluded = reader.bool();
                    break;
                case /* double cost */ 7:
                    message.cost = reader.double();
                    break;
                case /* int32 sort_order */ 8:
                    message.sortOrder = reader.int32();
                    break;
                case /* string order_by */ 9:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 10:
                    message.orderDir = reader.string();
                    break;
                case /* repeated string field_mask */ 11:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 12:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 13:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 membership_id = 2; */
        if (message.membershipId !== 0)
            writer.tag(2, WireType.Varint).int32(message.membershipId);
        /* int32 membership_line_id = 3; */
        if (message.membershipLineId !== 0)
            writer.tag(3, WireType.Varint).int32(message.membershipLineId);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* bool is_included = 6; */
        if (message.isIncluded !== false)
            writer.tag(6, WireType.Varint).bool(message.isIncluded);
        /* double cost = 7; */
        if (message.cost !== 0)
            writer.tag(7, WireType.Bit64).double(message.cost);
        /* int32 sort_order = 8; */
        if (message.sortOrder !== 0)
            writer.tag(8, WireType.Varint).int32(message.sortOrder);
        /* string order_by = 9; */
        if (message.orderBy !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 10; */
        if (message.orderDir !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.orderDir);
        /* repeated string field_mask = 11; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 12; */
        if (message.pageNumber !== 0)
            writer.tag(12, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 13; */
        if (message.withoutLimit !== false)
            writer.tag(13, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipInstanceLine
 */
export const MembershipInstanceLine = new MembershipInstanceLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipInstanceLineList$Type extends MessageType {
    constructor() {
        super("MembershipInstanceLineList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MembershipInstanceLine },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MembershipInstanceLine results */ 1:
                    message.results.push(MembershipInstanceLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MembershipInstanceLine results = 1; */
        for (let i = 0; i < message.results.length; i++)
            MembershipInstanceLine.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipInstanceLineList
 */
export const MembershipInstanceLineList = new MembershipInstanceLineList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipChannel$Type extends MessageType {
    constructor() {
        super("MembershipChannel", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.code = "";
        message.label = "";
        message.isActive = false;
        message.sortOrder = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string code */ 2:
                    message.code = reader.string();
                    break;
                case /* string label */ 3:
                    message.label = reader.string();
                    break;
                case /* bool is_active */ 4:
                    message.isActive = reader.bool();
                    break;
                case /* int32 sort_order */ 5:
                    message.sortOrder = reader.int32();
                    break;
                case /* string order_by */ 6:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 7:
                    message.orderDir = reader.string();
                    break;
                case /* repeated string field_mask */ 8:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 9:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 10:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string code = 2; */
        if (message.code !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.code);
        /* string label = 3; */
        if (message.label !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.label);
        /* bool is_active = 4; */
        if (message.isActive !== false)
            writer.tag(4, WireType.Varint).bool(message.isActive);
        /* int32 sort_order = 5; */
        if (message.sortOrder !== 0)
            writer.tag(5, WireType.Varint).int32(message.sortOrder);
        /* string order_by = 6; */
        if (message.orderBy !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 7; */
        if (message.orderDir !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.orderDir);
        /* repeated string field_mask = 8; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 9; */
        if (message.pageNumber !== 0)
            writer.tag(9, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 10; */
        if (message.withoutLimit !== false)
            writer.tag(10, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipChannel
 */
export const MembershipChannel = new MembershipChannel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipChannelList$Type extends MessageType {
    constructor() {
        super("MembershipChannelList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MembershipChannel },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MembershipChannel results */ 1:
                    message.results.push(MembershipChannel.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MembershipChannel results = 1; */
        for (let i = 0; i < message.results.length; i++)
            MembershipChannel.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipChannelList
 */
export const MembershipChannelList = new MembershipChannelList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipStatus$Type extends MessageType {
    constructor() {
        super("MembershipStatus", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.value = "";
        message.isActive = false;
        message.orderBy = "";
        message.orderDir = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string value */ 2:
                    message.value = reader.string();
                    break;
                case /* bool is_active */ 3:
                    message.isActive = reader.bool();
                    break;
                case /* string order_by */ 4:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 5:
                    message.orderDir = reader.string();
                    break;
                case /* repeated string field_mask */ 6:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 7:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 8:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string value = 2; */
        if (message.value !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.value);
        /* bool is_active = 3; */
        if (message.isActive !== false)
            writer.tag(3, WireType.Varint).bool(message.isActive);
        /* string order_by = 4; */
        if (message.orderBy !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 5; */
        if (message.orderDir !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.orderDir);
        /* repeated string field_mask = 6; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 7; */
        if (message.pageNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 8; */
        if (message.withoutLimit !== false)
            writer.tag(8, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipStatus
 */
export const MembershipStatus = new MembershipStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipStatusList$Type extends MessageType {
    constructor() {
        super("MembershipStatusList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MembershipStatus },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MembershipStatus results */ 1:
                    message.results.push(MembershipStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MembershipStatus results = 1; */
        for (let i = 0; i < message.results.length; i++)
            MembershipStatus.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipStatusList
 */
export const MembershipStatusList = new MembershipStatusList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RenewalReminderPreviewReq$Type extends MessageType {
    constructor() {
        super("RenewalReminderPreviewReq", [
            { no: 1, name: "membership_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "trigger_key", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.membershipId = 0;
        message.triggerKey = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 membership_id */ 1:
                    message.membershipId = reader.int32();
                    break;
                case /* string trigger_key */ 2:
                    message.triggerKey = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 membership_id = 1; */
        if (message.membershipId !== 0)
            writer.tag(1, WireType.Varint).int32(message.membershipId);
        /* string trigger_key = 2; */
        if (message.triggerKey !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.triggerKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RenewalReminderPreviewReq
 */
export const RenewalReminderPreviewReq = new RenewalReminderPreviewReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipDashboard$Type extends MessageType {
    constructor() {
        super("MembershipDashboard", [
            { no: 1, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "membership_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "property_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "contract_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "customer_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "customer_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "customer_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "billing_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "helcim_subscription_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "is_autobilling", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "payment_terms", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "po_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "payment_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "contract_date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "contract_date_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "renewal_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "has_commercial", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "wants_media_filter", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "single_plan_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "annual_value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 23, name: "cancelled_plans_value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 24, name: "scheduled_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 25, name: "slot_total", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 26, name: "invoiced_total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 27, name: "collected_total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 28, name: "sold_by_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 29, name: "sold_by_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 31, name: "pending_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "needs_review", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 33, name: "search_blob", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "contract_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "not_equals", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 36, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 37, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 38, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 39, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 40, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 41, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 42, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 43, name: "count_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.contractId = 0;
        message.membershipCount = 0;
        message.propertyCount = 0;
        message.contractNumber = "";
        message.customerUserId = 0;
        message.customerLabel = "";
        message.customerEmail = "";
        message.departmentId = 0;
        message.billingTypeId = 0;
        message.helcimSubscriptionId = 0;
        message.isAutobilling = 0;
        message.paymentTerms = "";
        message.poNumber = "";
        message.notes = "";
        message.paymentMethod = "";
        message.contractDateCreated = "";
        message.contractDateStarted = "";
        message.renewalDate = "";
        message.hasCommercial = 0;
        message.wantsMediaFilter = 0;
        message.singlePlanLabel = "";
        message.annualValue = 0;
        message.cancelledPlansValue = 0;
        message.scheduledCount = 0;
        message.slotTotal = 0;
        message.invoicedTotal = 0;
        message.collectedTotal = 0;
        message.soldByUserId = 0;
        message.soldByLabel = "";
        message.status = "";
        message.pendingReason = "";
        message.needsReview = 0;
        message.searchBlob = "";
        message.contractIdList = "";
        message.notEquals = [];
        message.dateRange = [];
        message.dateTarget = [];
        message.fieldMask = [];
        message.orderBy = "";
        message.orderDir = "";
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.countOnly = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 contract_id */ 1:
                    message.contractId = reader.int32();
                    break;
                case /* int32 membership_count */ 2:
                    message.membershipCount = reader.int32();
                    break;
                case /* int32 property_count */ 3:
                    message.propertyCount = reader.int32();
                    break;
                case /* string contract_number */ 4:
                    message.contractNumber = reader.string();
                    break;
                case /* int32 customer_user_id */ 5:
                    message.customerUserId = reader.int32();
                    break;
                case /* string customer_label */ 6:
                    message.customerLabel = reader.string();
                    break;
                case /* string customer_email */ 7:
                    message.customerEmail = reader.string();
                    break;
                case /* int32 department_id */ 8:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 billing_type_id */ 9:
                    message.billingTypeId = reader.int32();
                    break;
                case /* int32 helcim_subscription_id */ 10:
                    message.helcimSubscriptionId = reader.int32();
                    break;
                case /* int32 is_autobilling */ 11:
                    message.isAutobilling = reader.int32();
                    break;
                case /* string payment_terms */ 12:
                    message.paymentTerms = reader.string();
                    break;
                case /* string po_number */ 13:
                    message.poNumber = reader.string();
                    break;
                case /* string notes */ 14:
                    message.notes = reader.string();
                    break;
                case /* string payment_method */ 15:
                    message.paymentMethod = reader.string();
                    break;
                case /* string contract_date_created */ 16:
                    message.contractDateCreated = reader.string();
                    break;
                case /* string contract_date_started */ 17:
                    message.contractDateStarted = reader.string();
                    break;
                case /* string renewal_date */ 18:
                    message.renewalDate = reader.string();
                    break;
                case /* int32 has_commercial */ 19:
                    message.hasCommercial = reader.int32();
                    break;
                case /* int32 wants_media_filter */ 20:
                    message.wantsMediaFilter = reader.int32();
                    break;
                case /* string single_plan_label */ 21:
                    message.singlePlanLabel = reader.string();
                    break;
                case /* double annual_value */ 22:
                    message.annualValue = reader.double();
                    break;
                case /* double cancelled_plans_value */ 23:
                    message.cancelledPlansValue = reader.double();
                    break;
                case /* int32 scheduled_count */ 24:
                    message.scheduledCount = reader.int32();
                    break;
                case /* int32 slot_total */ 25:
                    message.slotTotal = reader.int32();
                    break;
                case /* double invoiced_total */ 26:
                    message.invoicedTotal = reader.double();
                    break;
                case /* double collected_total */ 27:
                    message.collectedTotal = reader.double();
                    break;
                case /* int32 sold_by_user_id */ 28:
                    message.soldByUserId = reader.int32();
                    break;
                case /* string sold_by_label */ 29:
                    message.soldByLabel = reader.string();
                    break;
                case /* string status */ 30:
                    message.status = reader.string();
                    break;
                case /* string pending_reason */ 31:
                    message.pendingReason = reader.string();
                    break;
                case /* int32 needs_review */ 32:
                    message.needsReview = reader.int32();
                    break;
                case /* string search_blob */ 33:
                    message.searchBlob = reader.string();
                    break;
                case /* string contract_id_list */ 34:
                    message.contractIdList = reader.string();
                    break;
                case /* repeated string not_equals */ 35:
                    message.notEquals.push(reader.string());
                    break;
                case /* repeated string date_range */ 36:
                    message.dateRange.push(reader.string());
                    break;
                case /* repeated string date_target */ 37:
                    message.dateTarget.push(reader.string());
                    break;
                case /* repeated string field_mask */ 38:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string order_by */ 39:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 40:
                    message.orderDir = reader.string();
                    break;
                case /* int32 page_number */ 41:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 42:
                    message.withoutLimit = reader.bool();
                    break;
                case /* bool count_only */ 43:
                    message.countOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 contract_id = 1; */
        if (message.contractId !== 0)
            writer.tag(1, WireType.Varint).int32(message.contractId);
        /* int32 membership_count = 2; */
        if (message.membershipCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.membershipCount);
        /* int32 property_count = 3; */
        if (message.propertyCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.propertyCount);
        /* string contract_number = 4; */
        if (message.contractNumber !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.contractNumber);
        /* int32 customer_user_id = 5; */
        if (message.customerUserId !== 0)
            writer.tag(5, WireType.Varint).int32(message.customerUserId);
        /* string customer_label = 6; */
        if (message.customerLabel !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.customerLabel);
        /* string customer_email = 7; */
        if (message.customerEmail !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.customerEmail);
        /* int32 department_id = 8; */
        if (message.departmentId !== 0)
            writer.tag(8, WireType.Varint).int32(message.departmentId);
        /* int32 billing_type_id = 9; */
        if (message.billingTypeId !== 0)
            writer.tag(9, WireType.Varint).int32(message.billingTypeId);
        /* int32 helcim_subscription_id = 10; */
        if (message.helcimSubscriptionId !== 0)
            writer.tag(10, WireType.Varint).int32(message.helcimSubscriptionId);
        /* int32 is_autobilling = 11; */
        if (message.isAutobilling !== 0)
            writer.tag(11, WireType.Varint).int32(message.isAutobilling);
        /* string payment_terms = 12; */
        if (message.paymentTerms !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.paymentTerms);
        /* string po_number = 13; */
        if (message.poNumber !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.poNumber);
        /* string notes = 14; */
        if (message.notes !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.notes);
        /* string payment_method = 15; */
        if (message.paymentMethod !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.paymentMethod);
        /* string contract_date_created = 16; */
        if (message.contractDateCreated !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.contractDateCreated);
        /* string contract_date_started = 17; */
        if (message.contractDateStarted !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.contractDateStarted);
        /* string renewal_date = 18; */
        if (message.renewalDate !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.renewalDate);
        /* int32 has_commercial = 19; */
        if (message.hasCommercial !== 0)
            writer.tag(19, WireType.Varint).int32(message.hasCommercial);
        /* int32 wants_media_filter = 20; */
        if (message.wantsMediaFilter !== 0)
            writer.tag(20, WireType.Varint).int32(message.wantsMediaFilter);
        /* string single_plan_label = 21; */
        if (message.singlePlanLabel !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.singlePlanLabel);
        /* double annual_value = 22; */
        if (message.annualValue !== 0)
            writer.tag(22, WireType.Bit64).double(message.annualValue);
        /* double cancelled_plans_value = 23; */
        if (message.cancelledPlansValue !== 0)
            writer.tag(23, WireType.Bit64).double(message.cancelledPlansValue);
        /* int32 scheduled_count = 24; */
        if (message.scheduledCount !== 0)
            writer.tag(24, WireType.Varint).int32(message.scheduledCount);
        /* int32 slot_total = 25; */
        if (message.slotTotal !== 0)
            writer.tag(25, WireType.Varint).int32(message.slotTotal);
        /* double invoiced_total = 26; */
        if (message.invoicedTotal !== 0)
            writer.tag(26, WireType.Bit64).double(message.invoicedTotal);
        /* double collected_total = 27; */
        if (message.collectedTotal !== 0)
            writer.tag(27, WireType.Bit64).double(message.collectedTotal);
        /* int32 sold_by_user_id = 28; */
        if (message.soldByUserId !== 0)
            writer.tag(28, WireType.Varint).int32(message.soldByUserId);
        /* string sold_by_label = 29; */
        if (message.soldByLabel !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.soldByLabel);
        /* string status = 30; */
        if (message.status !== "")
            writer.tag(30, WireType.LengthDelimited).string(message.status);
        /* string pending_reason = 31; */
        if (message.pendingReason !== "")
            writer.tag(31, WireType.LengthDelimited).string(message.pendingReason);
        /* int32 needs_review = 32; */
        if (message.needsReview !== 0)
            writer.tag(32, WireType.Varint).int32(message.needsReview);
        /* string search_blob = 33; */
        if (message.searchBlob !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.searchBlob);
        /* string contract_id_list = 34; */
        if (message.contractIdList !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.contractIdList);
        /* repeated string not_equals = 35; */
        for (let i = 0; i < message.notEquals.length; i++)
            writer.tag(35, WireType.LengthDelimited).string(message.notEquals[i]);
        /* repeated string date_range = 36; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(36, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 37; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(37, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* repeated string field_mask = 38; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(38, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string order_by = 39; */
        if (message.orderBy !== "")
            writer.tag(39, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 40; */
        if (message.orderDir !== "")
            writer.tag(40, WireType.LengthDelimited).string(message.orderDir);
        /* int32 page_number = 41; */
        if (message.pageNumber !== 0)
            writer.tag(41, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 42; */
        if (message.withoutLimit !== false)
            writer.tag(42, WireType.Varint).bool(message.withoutLimit);
        /* bool count_only = 43; */
        if (message.countOnly !== false)
            writer.tag(43, WireType.Varint).bool(message.countOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipDashboard
 */
export const MembershipDashboard = new MembershipDashboard$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipDashboardList$Type extends MessageType {
    constructor() {
        super("MembershipDashboardList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MembershipDashboard },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MembershipDashboard results */ 1:
                    message.results.push(MembershipDashboard.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MembershipDashboard results = 1; */
        for (let i = 0; i < message.results.length; i++)
            MembershipDashboard.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipDashboardList
 */
export const MembershipDashboardList = new MembershipDashboardList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipDashboardRow$Type extends MessageType {
    constructor() {
        super("MembershipDashboardRow", [
            { no: 1, name: "membership_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "membership_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "status_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "date_created", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "date_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "date_ended", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "cancel_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "cancel_timing", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "cancel_effective_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "created_by_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "channel_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "sold_on_event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "is_commercial", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 18, name: "type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "type_tier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "type_cost", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 21, name: "lines_total", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 22, name: "base_line_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "plan_label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "price_per_year", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 25, name: "slot_total", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 26, name: "scheduled_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 27, name: "completed_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 28, name: "next_visit_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "property_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "property_city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 31, name: "property_state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 32, name: "property_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 33, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 34, name: "pending_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 35, name: "payment_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 36, name: "contract_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 37, name: "membership_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 38, name: "not_equals", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 39, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 40, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 41, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 42, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 43, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 44, name: "count_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.membershipId = 0;
        message.contractId = 0;
        message.propertyId = 0;
        message.membershipTypeId = 0;
        message.statusId = 0;
        message.dateCreated = "";
        message.dateStarted = "";
        message.dateEnded = "";
        message.isActive = false;
        message.notes = "";
        message.cancelReason = "";
        message.cancelTiming = "";
        message.cancelEffectiveDate = "";
        message.createdByUserId = 0;
        message.channelId = 0;
        message.soldOnEventId = 0;
        message.isCommercial = false;
        message.typeName = "";
        message.typeTier = "";
        message.typeCost = 0;
        message.linesTotal = 0;
        message.baseLineName = "";
        message.planLabel = "";
        message.pricePerYear = 0;
        message.slotTotal = 0;
        message.scheduledCount = 0;
        message.completedCount = 0;
        message.nextVisitDate = "";
        message.propertyAddress = "";
        message.propertyCity = "";
        message.propertyState = "";
        message.propertyEmail = "";
        message.status = "";
        message.pendingReason = "";
        message.paymentMethod = "";
        message.contractIdList = "";
        message.membershipIdList = "";
        message.notEquals = [];
        message.fieldMask = [];
        message.orderBy = "";
        message.orderDir = "";
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.countOnly = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 membership_id */ 1:
                    message.membershipId = reader.int32();
                    break;
                case /* int32 contract_id */ 2:
                    message.contractId = reader.int32();
                    break;
                case /* int32 property_id */ 3:
                    message.propertyId = reader.int32();
                    break;
                case /* int32 membership_type_id */ 4:
                    message.membershipTypeId = reader.int32();
                    break;
                case /* int32 status_id */ 5:
                    message.statusId = reader.int32();
                    break;
                case /* string date_created */ 6:
                    message.dateCreated = reader.string();
                    break;
                case /* string date_started */ 7:
                    message.dateStarted = reader.string();
                    break;
                case /* string date_ended */ 8:
                    message.dateEnded = reader.string();
                    break;
                case /* bool is_active */ 9:
                    message.isActive = reader.bool();
                    break;
                case /* string notes */ 10:
                    message.notes = reader.string();
                    break;
                case /* string cancel_reason */ 11:
                    message.cancelReason = reader.string();
                    break;
                case /* string cancel_timing */ 12:
                    message.cancelTiming = reader.string();
                    break;
                case /* string cancel_effective_date */ 13:
                    message.cancelEffectiveDate = reader.string();
                    break;
                case /* int32 created_by_user_id */ 14:
                    message.createdByUserId = reader.int32();
                    break;
                case /* int32 channel_id */ 15:
                    message.channelId = reader.int32();
                    break;
                case /* int32 sold_on_event_id */ 16:
                    message.soldOnEventId = reader.int32();
                    break;
                case /* bool is_commercial */ 17:
                    message.isCommercial = reader.bool();
                    break;
                case /* string type_name */ 18:
                    message.typeName = reader.string();
                    break;
                case /* string type_tier */ 19:
                    message.typeTier = reader.string();
                    break;
                case /* double type_cost */ 20:
                    message.typeCost = reader.double();
                    break;
                case /* double lines_total */ 21:
                    message.linesTotal = reader.double();
                    break;
                case /* string base_line_name */ 22:
                    message.baseLineName = reader.string();
                    break;
                case /* string plan_label */ 23:
                    message.planLabel = reader.string();
                    break;
                case /* double price_per_year */ 24:
                    message.pricePerYear = reader.double();
                    break;
                case /* int32 slot_total */ 25:
                    message.slotTotal = reader.int32();
                    break;
                case /* int32 scheduled_count */ 26:
                    message.scheduledCount = reader.int32();
                    break;
                case /* int32 completed_count */ 27:
                    message.completedCount = reader.int32();
                    break;
                case /* string next_visit_date */ 28:
                    message.nextVisitDate = reader.string();
                    break;
                case /* string property_address */ 29:
                    message.propertyAddress = reader.string();
                    break;
                case /* string property_city */ 30:
                    message.propertyCity = reader.string();
                    break;
                case /* string property_state */ 31:
                    message.propertyState = reader.string();
                    break;
                case /* string property_email */ 32:
                    message.propertyEmail = reader.string();
                    break;
                case /* string status */ 33:
                    message.status = reader.string();
                    break;
                case /* string pending_reason */ 34:
                    message.pendingReason = reader.string();
                    break;
                case /* string payment_method */ 35:
                    message.paymentMethod = reader.string();
                    break;
                case /* string contract_id_list */ 36:
                    message.contractIdList = reader.string();
                    break;
                case /* string membership_id_list */ 37:
                    message.membershipIdList = reader.string();
                    break;
                case /* repeated string not_equals */ 38:
                    message.notEquals.push(reader.string());
                    break;
                case /* repeated string field_mask */ 39:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string order_by */ 40:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 41:
                    message.orderDir = reader.string();
                    break;
                case /* int32 page_number */ 42:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 43:
                    message.withoutLimit = reader.bool();
                    break;
                case /* bool count_only */ 44:
                    message.countOnly = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 membership_id = 1; */
        if (message.membershipId !== 0)
            writer.tag(1, WireType.Varint).int32(message.membershipId);
        /* int32 contract_id = 2; */
        if (message.contractId !== 0)
            writer.tag(2, WireType.Varint).int32(message.contractId);
        /* int32 property_id = 3; */
        if (message.propertyId !== 0)
            writer.tag(3, WireType.Varint).int32(message.propertyId);
        /* int32 membership_type_id = 4; */
        if (message.membershipTypeId !== 0)
            writer.tag(4, WireType.Varint).int32(message.membershipTypeId);
        /* int32 status_id = 5; */
        if (message.statusId !== 0)
            writer.tag(5, WireType.Varint).int32(message.statusId);
        /* string date_created = 6; */
        if (message.dateCreated !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.dateCreated);
        /* string date_started = 7; */
        if (message.dateStarted !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.dateStarted);
        /* string date_ended = 8; */
        if (message.dateEnded !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.dateEnded);
        /* bool is_active = 9; */
        if (message.isActive !== false)
            writer.tag(9, WireType.Varint).bool(message.isActive);
        /* string notes = 10; */
        if (message.notes !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.notes);
        /* string cancel_reason = 11; */
        if (message.cancelReason !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.cancelReason);
        /* string cancel_timing = 12; */
        if (message.cancelTiming !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.cancelTiming);
        /* string cancel_effective_date = 13; */
        if (message.cancelEffectiveDate !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.cancelEffectiveDate);
        /* int32 created_by_user_id = 14; */
        if (message.createdByUserId !== 0)
            writer.tag(14, WireType.Varint).int32(message.createdByUserId);
        /* int32 channel_id = 15; */
        if (message.channelId !== 0)
            writer.tag(15, WireType.Varint).int32(message.channelId);
        /* int32 sold_on_event_id = 16; */
        if (message.soldOnEventId !== 0)
            writer.tag(16, WireType.Varint).int32(message.soldOnEventId);
        /* bool is_commercial = 17; */
        if (message.isCommercial !== false)
            writer.tag(17, WireType.Varint).bool(message.isCommercial);
        /* string type_name = 18; */
        if (message.typeName !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.typeName);
        /* string type_tier = 19; */
        if (message.typeTier !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.typeTier);
        /* double type_cost = 20; */
        if (message.typeCost !== 0)
            writer.tag(20, WireType.Bit64).double(message.typeCost);
        /* double lines_total = 21; */
        if (message.linesTotal !== 0)
            writer.tag(21, WireType.Bit64).double(message.linesTotal);
        /* string base_line_name = 22; */
        if (message.baseLineName !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.baseLineName);
        /* string plan_label = 23; */
        if (message.planLabel !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.planLabel);
        /* double price_per_year = 24; */
        if (message.pricePerYear !== 0)
            writer.tag(24, WireType.Bit64).double(message.pricePerYear);
        /* int32 slot_total = 25; */
        if (message.slotTotal !== 0)
            writer.tag(25, WireType.Varint).int32(message.slotTotal);
        /* int32 scheduled_count = 26; */
        if (message.scheduledCount !== 0)
            writer.tag(26, WireType.Varint).int32(message.scheduledCount);
        /* int32 completed_count = 27; */
        if (message.completedCount !== 0)
            writer.tag(27, WireType.Varint).int32(message.completedCount);
        /* string next_visit_date = 28; */
        if (message.nextVisitDate !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.nextVisitDate);
        /* string property_address = 29; */
        if (message.propertyAddress !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.propertyAddress);
        /* string property_city = 30; */
        if (message.propertyCity !== "")
            writer.tag(30, WireType.LengthDelimited).string(message.propertyCity);
        /* string property_state = 31; */
        if (message.propertyState !== "")
            writer.tag(31, WireType.LengthDelimited).string(message.propertyState);
        /* string property_email = 32; */
        if (message.propertyEmail !== "")
            writer.tag(32, WireType.LengthDelimited).string(message.propertyEmail);
        /* string status = 33; */
        if (message.status !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.status);
        /* string pending_reason = 34; */
        if (message.pendingReason !== "")
            writer.tag(34, WireType.LengthDelimited).string(message.pendingReason);
        /* string payment_method = 35; */
        if (message.paymentMethod !== "")
            writer.tag(35, WireType.LengthDelimited).string(message.paymentMethod);
        /* string contract_id_list = 36; */
        if (message.contractIdList !== "")
            writer.tag(36, WireType.LengthDelimited).string(message.contractIdList);
        /* string membership_id_list = 37; */
        if (message.membershipIdList !== "")
            writer.tag(37, WireType.LengthDelimited).string(message.membershipIdList);
        /* repeated string not_equals = 38; */
        for (let i = 0; i < message.notEquals.length; i++)
            writer.tag(38, WireType.LengthDelimited).string(message.notEquals[i]);
        /* repeated string field_mask = 39; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(39, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string order_by = 40; */
        if (message.orderBy !== "")
            writer.tag(40, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 41; */
        if (message.orderDir !== "")
            writer.tag(41, WireType.LengthDelimited).string(message.orderDir);
        /* int32 page_number = 42; */
        if (message.pageNumber !== 0)
            writer.tag(42, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 43; */
        if (message.withoutLimit !== false)
            writer.tag(43, WireType.Varint).bool(message.withoutLimit);
        /* bool count_only = 44; */
        if (message.countOnly !== false)
            writer.tag(44, WireType.Varint).bool(message.countOnly);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipDashboardRow
 */
export const MembershipDashboardRow = new MembershipDashboardRow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MembershipDashboardRowList$Type extends MessageType {
    constructor() {
        super("MembershipDashboardRowList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => MembershipDashboardRow },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated MembershipDashboardRow results */ 1:
                    message.results.push(MembershipDashboardRow.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated MembershipDashboardRow results = 1; */
        for (let i = 0; i < message.results.length; i++)
            MembershipDashboardRow.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MembershipDashboardRowList
 */
export const MembershipDashboardRowList = new MembershipDashboardRowList$Type();
/**
 * @generated ServiceType for protobuf service MembershipService
 */
export const MembershipService = new ServiceType("MembershipService", [
    { name: "Create", options: {}, I: Membership, O: Membership },
    { name: "Get", options: {}, I: Membership, O: Membership },
    { name: "BatchGet", options: {}, I: Membership, O: MembershipList },
    { name: "Update", options: {}, I: Membership, O: Membership },
    { name: "Delete", options: {}, I: Membership, O: Empty },
    { name: "CreateMembershipLine", options: {}, I: MembershipLine, O: MembershipLine },
    { name: "GetMembershipLine", options: {}, I: MembershipLine, O: MembershipLine },
    { name: "BatchGetMembershipLine", options: {}, I: MembershipLine, O: MembershipLineList },
    { name: "UpdateMembershipLine", options: {}, I: MembershipLine, O: MembershipLine },
    { name: "DeleteMembershipLine", options: {}, I: MembershipLine, O: Empty },
    { name: "CreateMembershipType", options: {}, I: MembershipType, O: MembershipType },
    { name: "GetMembershipType", options: {}, I: MembershipType, O: MembershipType },
    { name: "BatchGetMembershipType", options: {}, I: MembershipType, O: MembershipTypeList },
    { name: "UpdateMembershipType", options: {}, I: MembershipType, O: MembershipType },
    { name: "DeleteMembershipType", options: {}, I: MembershipType, O: Empty },
    { name: "CreateMembershipTypeLine", options: {}, I: MembershipTypeLine, O: MembershipTypeLine },
    { name: "GetMembershipTypeLine", options: {}, I: MembershipTypeLine, O: MembershipTypeLine },
    { name: "BatchGetMembershipTypeLine", options: {}, I: MembershipTypeLine, O: MembershipTypeLineList },
    { name: "UpdateMembershipTypeLine", options: {}, I: MembershipTypeLine, O: MembershipTypeLine },
    { name: "DeleteMembershipTypeLine", options: {}, I: MembershipTypeLine, O: Empty },
    { name: "CreateMembershipInstanceLine", options: {}, I: MembershipInstanceLine, O: MembershipInstanceLine },
    { name: "GetMembershipInstanceLine", options: {}, I: MembershipInstanceLine, O: MembershipInstanceLine },
    { name: "BatchGetMembershipInstanceLine", options: {}, I: MembershipInstanceLine, O: MembershipInstanceLineList },
    { name: "UpdateMembershipInstanceLine", options: {}, I: MembershipInstanceLine, O: MembershipInstanceLine },
    { name: "DeleteMembershipInstanceLine", options: {}, I: MembershipInstanceLine, O: Empty },
    { name: "BatchGetMembershipChannel", options: {}, I: MembershipChannel, O: MembershipChannelList },
    { name: "BatchGetMembershipStatus", options: {}, I: MembershipStatus, O: MembershipStatusList },
    { name: "BatchCreateMembership", options: {}, I: BatchCreateMembershipRequest, O: MembershipList },
    { name: "BatchGetMembershipDashboard", options: {}, I: MembershipDashboard, O: MembershipDashboardList },
    { name: "BatchGetMembershipDashboardRow", options: {}, I: MembershipDashboardRow, O: MembershipDashboardRowList },
    { name: "SendRenewalReminderPreview", options: {}, I: RenewalReminderPreviewReq, O: Bool }
]);
